import gsap from 'gsap'
import scrollTrigger from 'gsap/ScrollTrigger'

export default class {
  container: HTMLElement

  constructor(container: HTMLElement) {
    this.container = container
    if (this.container) this.init()
  }

  private init() {
    gsap.registerPlugin(scrollTrigger)

    const triggers = document.querySelectorAll('#main > [id]')

    if (triggers.length) {
      const menuItems = this.container.querySelectorAll('.float-menu__item') as NodeListOf<HTMLElement>

      triggers.forEach(trigger => {
        scrollTrigger.create({
          trigger,
          start: 'top top',
          onUpdate: e => {
            const item = Array.from(menuItems).find(
              menuItem => menuItem.getAttribute('href') === '#' + e.trigger?.getAttribute('id'),
            )

            if (item) {
              menuItems.forEach(item => item.classList.remove('is-active'))
              item.classList.add('is-active')
            }
          },
        })
      })
    }
  }
}
